import React, { useState } from 'react';
import {
  centerDivStyle,
  resultPersonaStyle,
  resultRowContentContainerStyle,
  resultRowContentStyle,
  resultRowIconButtonStyle,
  resultRowStyle,
} from '../style';
import { IconButton, Persona } from '@fluentui/react';

interface BookmarkResultProps {
  label: string;
  url: string;
}

const BookmarkResult: React.FC<BookmarkResultProps> = ({ label, url }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleClick = () => {
    window.open(url, '_blank');
  };
  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        ...resultRowStyle,
        ...{
          borderLeft: isHovered ? '2px solid deeppink' : '2px solid white',
        },
      }}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleClick();
        }
      }}
    >
      <div style={resultRowContentContainerStyle}>
        <div style={centerDivStyle}>
          <Persona text={label} coinSize={20} styles={resultPersonaStyle} />
        </div>
        <div style={resultRowContentStyle}>{`${label} (${url})`}</div>
        <div style={{ display: 'flex' }}>
          <IconButton
            iconProps={{
              iconName: 'SingleBookmarkSolid',
              style: { color: 'deeppink' },
            }}
            title='Open Bookmark'
            styles={resultRowIconButtonStyle}
          />
        </div>
      </div>
    </div>
  );
};

export default BookmarkResult;
